module.exports = __webpack_public_path__ + "img/1A.64b73db8.jpg";